// Environment configuration for API endpoints
const isDevelopment = import.meta.env.DEV
const isProduction = import.meta.env.PROD

// API Base URLs - Direct API calls for all environments
export const API_CONFIG = {
  MOMENTSCIENCE_API: 'https://api.momentscience.com',
  ADSPOSTX_API: 'https://api.adspostx.com/',
}

// Default base URL (using AdsPostX API)
export const DEFAULT_BASE_URL = API_CONFIG.ADSPOSTX_API

// API Environment info
export const API_ENVIRONMENT = {
  isDevelopment,
  isProduction,
  usingProxy: false,
  baseUrl: DEFAULT_BASE_URL,
  momentScienceUrl: API_CONFIG.MOMENTSCIENCE_API,
  adsPostXUrl: API_CONFIG.ADSPOSTX_API,
}

// Default headers - Only Content-Type for Moments API
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
}

// Default API key (should be replaced with real key)
export const DEFAULT_API_KEY = 'b9a31935-a222-4bdd-bfc6-a63e6bb01e39'

// Documentation URLs
export const DOCUMENTATION_URLS = {
  MOMENTS_API: 'https://docs.momentscience.com/reference/native-v2-offers-json',
  ADSPOSTX_API: 'https://docs.adspostx.com/reference/api',
}
